import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@mui/material';
import { useBreakpoints } from 'hooks';

import { AuthModal } from 'interfaces/auth';

import { Button } from 'components/_basic/Button/Button';
import { Modal } from 'components/_basic/Modal';
import { useAuthModalsContext } from 'components/AuthModals';

import { ISaveProjectModalProps as IProps } from './types';

import styles from './SaveProjectModal.module.scss';

export const SaveProjectModal: FC<IProps> = ({ onClose, title, description }) => {
  const { t } = useTranslation();
  const { setAuthModal, setIsModalOpened } = useAuthModalsContext();
  const { isMobile } = useBreakpoints();

  const handleSignInModalOpen = (): void => {
    setAuthModal(AuthModal.LOGIN);
    setIsModalOpened(true);
    onClose();
  };
  const handleSignUpModalOpen = (): void => {
    setAuthModal(AuthModal.SIGN_UP);
    setIsModalOpened(true);
    onClose();
  };

  return (
    <Modal close={onClose}>
      <Box className={styles.wrapper}>
        <Typography variant={isMobile ? 'h4' : 'h3'} className={styles.title}>
          {title}
        </Typography>
        <Typography variant="body2" className={styles.text}>
          {description}
        </Typography>
        <Box className={styles.buttonWrapper}>
          <Button variant="outlined" size="small" color="primary" onClick={onClose}>
            {t('cancel')}
          </Button>
          <Button variant="contained" size="small" color="primary" onClick={ isMobile ? handleSignUpModalOpen : handleSignInModalOpen}>
            {isMobile ? t('signUp') : t('logIn')}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
